<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div v-if="pendingPayment.payee.organizationPayeeId" class="mb-4 mx-5"><font-awesome-icon size="sm" class="text-warning align-baseline mr-2" icon="exclamation-triangle"/>By submitting payment confirmation anchor provider attests covered services rendered are complete and documented.</div>
          <div class="col-3">
          </div>
          <div class="col-8">
              <div v-if="pendingPayment.payee.organizationPayeeId" class="col-8">
                <b-form-group><span class="confirm-label mb-2">Participating Provider: </span>
                  <span class="confirm-text"> {{ pendingPayment.payee.businessName }}</span></b-form-group><br>
                <b-form-group><span class="confirm-label">TIN: </span>
                  <span class="confirm-text">{{ pendingPayment.payee.taxId }}</span></b-form-group><br>
              <b-form-group><span class="confirm-label" >NPI: </span>
                  <span class="confirm-text">{{ pendingPayment.payee.npi }}</span></b-form-group><br>
                <b-form-group :state="stateForField('organizationAccountId')" :invalid-feedback="errorForField('organizationAccountId')"><span class="confirm-label" >Account: </span>
                  <span class="confirm-text">{{ pendingPayment.pendingAccount.name + ' (' + pendingPayment.pendingAccount.last4 + ')' }}</span></b-form-group><br>
              <div>
                 <b-form-group :state="stateForField('amount')" :invalid-feedback="errorForField('amount')"><span class="confirm-label" >Amount: </span><span  class="confirm-text">{{ '$' + formatNumber(pendingPayment.pendingAmount) }}</span></b-form-group></div><br>
              </div>
              <div class="set-payee my-4" v-else >
                <font-awesome-icon size="sm" class="text-warning align-baseline mr-2" icon="exclamation-triangle"/>Set participating provider information before continuing
              </div>
          </div>
          </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Send Payment
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Cancel</button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'
  import _ from 'lodash'

  export default {
    name: 'SendBundlePaymentModal',

    mixins: [ErrorsMixin],

    components: { },

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      payment: {
        type: Object,
        required: false
      },
      availableFunds: {
        type: Number,
        required: false
      }
    },

    data () {
      return {
        pendingPayment: {
          pendingAmount: 0,
          pendingAccount: {
            last4: 0,
            name: ''
          },
          payee: {
            organizationPayeeId: 0,
            businessName: '',
            firstName: '',
            lastName: ''
          }
        },
        isSaving: false
      }
    },

    watch: {
      visible (newValue) {
        this.clearAllErrors()
        if (newValue) {
          this.pendingPayment = _.clone(this.payment)
          console.log(this.pendingPayment)
        }
      }
    },

    computed: {
      title () {
        if (this.pendingPayment) {
          console.log(this.pendingPayment)

          const name = this.payeeDisplayName(this.pendingPayment.payee)
          if (name) {
            return 'Send Payment to ' + name
          }
        }

        return 'Send Payment'
      }
    },

    methods: {
      save () {
        if (this.isSaving) {
          return
        }
        this.clearAllErrors()
        this.isSaving = true

        const transfer = {
          organizationAccountId: this.pendingPayment.pendingAccount.organizationAccountId,
          organizationBundlePaymentDistributionServiceId: this.pendingPayment.organizationBundlePaymentDistributionServiceId,
          amount: this.pendingPayment.pendingAmount
        }
        api.post('/Dashboard/PaymentDistribution/' + this.pendingPayment.organizationBundlePaymentDistributionId + '/Pay', transfer).then(response => {
          this.$emit('paymentConfirmed')
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to fund payment distribution: ' + error.message, error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      formatNumber (number) {
        if (number === 0 || number === 0.0) {
          return '0.00'
        }
        if (typeof number === 'number') {
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }
        if (typeof number === 'string') {
          const integer = Number(number)
          return integer.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }
        return ''
      },

      payeeDisplayName (payee) {
        let displayName = ''
        if (payee.businessName) {
          displayName = payee.businessName
        }

        if (payee.firstName) {
          if (displayName) {
            displayName += ', '
          }
          displayName += payee.firstName
        }

        if (payee.lastName) {
          displayName += ' ' + payee.lastName
        }

        return displayName
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    },

    created () {
    }
  }
</script>

<style scoped>
.confirm-label {
  font-size: 1rem;
  color: #737284;
  margin-bottom: 1rem;
}

.confirm-text {
  color: #333;
  font-size: 1rem;
}

.set-payee {
  font-size: 1rem;
}
</style>
